import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useIdentityManager } from '../../../common/hooks/useIdentityManager';
import NavigationButton from './navigationButton/navigationButton';
import useClickOutside from '../../../common/hooks/useClickOutside';
import useTranslate from '../../../common/hooks/useTranslate';

import './userNavigation.scss';

interface INavigation {
  setNav: (state: boolean) => void;
  id: string;
}

const UserNavigation: React.FC<INavigation> = ({ setNav, id }) => {
  const identity = useIdentityManager();
  const wrapperRef = useRef(null);
  const { t } = useTranslate();

  const clickOutsideHandler = () => {
    setNav(false);
  };
  useClickOutside(wrapperRef, clickOutsideHandler, id);

  return (
    <div className={'UserNav'} ref={wrapperRef}>
      <Link to="/profile">
        <button onClick={() => setNav(false)}>
          <NavigationButton label={t('NAVIGATION.PROFILE')} iconName="fa-user" />
        </button>
      </Link>
      <button onClick={() => identity.signOut()}>
        <NavigationButton label={t('NAVIGATION.LOGOUT')} iconName="fa-door-open" />
      </button>
    </div>
  );
};

export default UserNavigation;
